"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToast = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
const StyledToast = styled_components_1.default.div `
  background: ${({ status }) => status === 'success' ? config_1.colors.blurple : config_1.colors.redError};
  position: absolute;
  z-index: 2000;
  top: 15%;
  left: 50%;
  padding: 16px;
  color: ${config_1.colors.white};

  font: ${config_1.fontSizes.small} ${config_1.fontFamilies.primary};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  alignt-items: center;
`;
exports.StyledToast = StyledToast;
